export default __webpack_public_path__ + "static/media/1018.a7e85f7b.svg";